<template>
<div>
    <loader v-show="isLoading" />
    <div class="tabContent">
        <div class="sectionHeader">
            <div class="sectionHeaderLeft">E106 Compliance Request</div>
        </div>
        <div style="float: clear" v-show="gridSpecCompliance.tableData.length > 0">
            <v-client-table :data="gridSpecCompliance.tableData" :columns="gridSpecCompliance.columns" :options="gridSpecCompliance.options">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center;">
                        <router-link :to="{ path: '/E106Compliance/' + props.row.e106complianceId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                    </div>
                </template>
            </v-client-table>
        </div>
        <div class="sectionHeader">
            <div class="sectionHeaderLeft">File Search</div>
            <div class="sectionHeaderRight" v-show="isShpo">
                <router-link :to="{ path: '/FileSearch', query: { projectId: project.projectId }}" tag="button" class="btn btn-primary btn-block">Add New</router-link>
            </div>
        </div>
        <div style="float: clear" v-if="isShpo">
            <v-client-table :data="gridSpecFileSearches.tableData" :columns="gridSpecFileSearches.columns" :options="gridSpecFileSearches.options">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center;">
                        <router-link :to="{ path: '/FileSearch/' + props.row.fileSearchId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                    </div>
                </template>
                <template slot="result" slot-scope="props">
                    <div style="text-align: center;" v-if="props.row.hasResults">
                        <router-link :to="{ path: '/FileSearch/' + props.row.fileSearchId, hash: '#files' }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                    </div>
                </template>
                <template slot="delete" slot-scope="props">
                    <div style="text-align: center;">
                        <a class="fa fa-ban" style="font-size: 18px;" v-if="props.row.canBeDeleted" v-on:click="deleteFileSearch(props.row.fileSearchId)"></a>
                    </div>
                </template>
            </v-client-table>
        </div>
        <div v-else class="alert alert-info" role="alert">
            <strong>The file search will be performed by SHPO</strong>
        </div>
        &nbsp;<br/> <!-- BUG! not sure why the next section header doesnt show if I don't have this -->
        <div class="sectionHeader">
            <div class="sectionHeaderLeft">Investigation</div>
            <div class="sectionHeaderRight" v-show="isShpo">
                <button tag="button" class="btn btn-primary btn-block" v-on:click="CreateE106Investigation">Add New</button>
            </div>
        </div>
        <div style="float: clear" v-if="isShpo">
            <v-client-table :data="gridSpecInvestigations.tableData" :columns="gridSpecInvestigations.columns" :options="gridSpecInvestigations.options">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center">
                        <router-link :to="{ path: '/Investigation/' + props.row.investigationId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                    </div>
                </template>
            </v-client-table>
        </div>
        <div v-else class="alert alert-info" role="alert">
            <strong>The investigation will be performed by SHPO</strong>
        </div>
    </div>
</div>
</template>

<script>

import fileSearchService from '@/services/fileSearchService'
import e106ComplianceService from '@/services/e106ComplianceService'
import investigationService from '@/services/investigationService'
import loggingService from '@/services/util/loggingService'
import userService from '@/services/userService'
import roleService from '@/services/roleService'

import loader from '@/components/Loader'
import projectHeader from '@/components/ProjectHeader'
import { mapState } from 'vuex'

export default {
    name: 'complianceActions',
    props: ['project'],
    components: {
        loader,
        projectHeader
    },
    computed: {
        isShpo: function () {
            // var acceptableRoles = [
            //     roleService.RoleEnum.Administrator,
            //     roleService.RoleEnum.ShpoAdministrator,
            //     roleService.RoleEnum.ShpoRcAdministrator
            // ]
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList)
        },
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        })
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            compliance: {},
            gridSpecCompliance: {
                columns: ['edit', 'workflowStatusDescription', 'projectDescription', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    dateColumns: ['reportDate'],
                    headings: {
                        edit: 'View/Edit',
                        workflowStatusDescription: 'Status',
                        projectDescription: 'Project Description',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            gridSpecFileSearches: {
                columns: ['edit', 'workflowStatusDescription', 'fileSearchId', 'createdDate', 'plssLocationCount', 'billAmount', 'result', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    dateColumns: ['createdDate'],
                    headings: {
                        fileSearchId: 'File Search #',
                        createdDate: 'Date of Entry',
                        workflowStatusDescription: 'Status',
                        plssLocationCount: '# of Sections',
                        billAmount: 'Bill Amount',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            gridSpecInvestigations: {
                columns: ['edit', 'workflowStatusDescription', 'dbNumber', 'reportTitle', 'reportDate', 'resources', 'assignedAgent', 'fieldworkStartDate', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['reportDate'],
                    headings: {
                        edit: 'View/Edit',
                        workflowStatusDescription: 'Status',
                        dbNumber: 'DB Number',
                        reportDate: 'Report Date',
                        reportTitle: 'Report Title',
                        resources: 'Resources',
                        assignedAgent: 'Assigned Agent',
                        fieldworkStartDate: 'Fieldwork Start Date',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'reportDate'
                    }
                }
            }
        }
    },
    mounted () {
        this.log('mounted')
        this.loadActions()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'BuildingReconForm', message)
        },
        loadActions () {
            if (!this.project.projectId) {
                this.log('No projectId, not loading actions')
                return
            }
            this.isLoading = true
            this.log('Loading actions')
            var searchDto = {projectId: this.project.projectId}
            var compliancePromise = e106ComplianceService.search(this.$http, searchDto).then(comResponse => {
                this.log('loadActions - e106Compliance.search: ' + comResponse.data.length)

                this.compliance = comResponse.data[0]
                this.gridSpecCompliance.tableData = comResponse.data
                return comResponse
            })
            var fileSearchPromise = fileSearchService.search(this.$http, searchDto).then(fisResponse => {
                this.log('loadActions - fileSearchService.search')
                this.gridSpecFileSearches.tableData = fisResponse.data
                return fisResponse
            })
            var investigationPromise = investigationService.search(this.$http, searchDto).then(invResponse => {
                this.log('loadActions - investigationService.search')
                this.gridSpecInvestigations.tableData = invResponse.data
                return invResponse
            })
            Promise.all([compliancePromise, fileSearchPromise, investigationPromise]).then(results => {
                this.isLoading = false
            })
        },
        CreateE106Investigation () {
            if (!this.project.projectId) return
            // investigationService.createE106Investigation(this.$http, this.project.projectId).then(result => {
            //     this.$router.push('/Investigation/' + result.data.id)
            // })
            this.$router.push(`/Investigation?projectId=${this.project.projectId}&e106=true`)
        }
    }
}
</script>


<style>

.text-label {
    line-height: 24px !important;
}

.tabContent {
    margin-left: 30px;
}

.sectionHeader {
    overflow: hidden;
}

.sectionHeaderLeft {
    float: left;
    font-size: 18px;
}

.sectionHeaderRight {
    float: right;
}

</style>



// WEBPACK FOOTER //
// E106ComplianceActions.vue?2ae4f31b